import { selectCurrentHotelId } from 'accessors'
import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import HighlightedText from '../../../components/ReusableComponents/HighlightedText'
import SiteIcon from '../../../components/ReusableComponents/SiteIcon/index'
import { AdminHelper } from './AdminHelper'

function getNameDisplayString(hotel, isDemoMode) {
  if (isDemoMode) return `Hotel ${hotel.displayId}`
  const prefix = hotel.displayId ? `#${hotel.displayId} ` : ''
  return prefix + (hotel.shortName || '')
}

export const Subsidiary = ({
  hotel,
  groupName,
  searchParam,
  handleSelect,
  isInternalAdmin
}) => {
  const targetRef = useRef()
  const [pos, setPos] = useState({})
  const [isHovering, setHovering] = useState(false)

  const currentHotelId = useSelector(selectCurrentHotelId)
  const isDemoMode = useSelector(s => s.login.isDemoMode)

  const nameDisplayString = getNameDisplayString(hotel, isDemoMode)
  const hasSearch = searchParam != null && String(searchParam).trim() !== ''

  return (
    <li
      key={hotel.subsidiaryId}
      ref={targetRef}
      onMouseOver={() => {
        if (!isHovering) {
          setPos(targetRef.current && targetRef.current.getBoundingClientRect())
        }
        setHovering(true)
      }}
      onMouseOut={() => setHovering(false)}
    >
      <button
        onClick={() => handleSelect(hotel)}
        className={currentHotelId === hotel.subsidiaryId ? 'hotel-selector-active' : ''}
      >
        {!isDemoMode && (
          <div className="hotel-selector__hotel-icon-group">
            <SiteIcon url={hotel.websiteAddress} />
            {isInternalAdmin && (
              <AdminHelper
                subsidiary={hotel}
                pos={pos}
                showTooltip={isHovering}
                subsidiaryId={hotel.subsidiaryId}
              />
            )}
          </div>
        )}
        <div className="hotel-selector__hotel-name-group" title={hotel.subsidiaryName}>
          {!isDemoMode && <div className="hotel-selector__url">{hotel.brand}</div>}
          <div className="hotel-selector__name">
            {hasSearch ? (
              <HighlightedText text={nameDisplayString} query={searchParam} />
            ) : (
              <>
                {hotel.displayId && isInternalAdmin && !isDemoMode && (
                  <span className="hotel-selector__displayId">#{hotel.displayId}</span>
                )}
                {isDemoMode ? `Hotel ${hotel.displayId}` : hotel.shortName}
              </>
            )}
          </div>
        </div>
      </button>
    </li>
  )
}
